import 'twin.macro';

const TextWithIcon = ({ handleClickSection, icon, text, disabled = false }) => {
  return (
    <div
      tw="flex items-center gap-[12px] px-[12px] py-[12px] w-full"
      className={disabled ? 'setting-menu-disabled' : 'setting-menu'}
      style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : { cursor: 'pointer' }}
      onClick={disabled ? undefined : handleClickSection}
    >
      <div tw="w-[20px] h-[20px] flex items-center justify-center shrink-0 text-gray-text">
        {icon}
      </div>
      <p tw="text-gray-text text-[16px] font-medium flex-1">{text}</p>
    </div>
  );
};

export default TextWithIcon;
